// Drag payload constants shared by the palette, the canvas and the
// DndContext handlers so every side agrees on what an `active.data.current`
// looks like.

// Where a dragged thing came from
export const SOURCE = {
  PALETTE: 'palette',
  SECTION: 'section',
  SECTION_HANDLE: 'sectionHandle',
}

// What kind of thing is being dragged / dropped
export const KIND = {
  CONSUMABLE: 'consumable',
  ASSET: 'asset',
  ASSET_WILDCARD: 'assetWildcard',
}

// Which list on a section a chip lives in
export const ROW = {
  CONSUMABLES: 'requiredConsumables',
  ASSETS: 'requiredAssets',
}

export const rowForKind = (kind) =>
  kind === KIND.CONSUMABLE ? ROW.CONSUMABLES : ROW.ASSETS

// dnd-kit ids
export const sectionDropId = (sectionClientId) => `section:${sectionClientId}`
export const sectionSortId = (sectionClientId) =>
  `section-sort:${sectionClientId}`
export const chipSortId = (sectionClientId, chipClientId) =>
  `${sectionClientId}:${chipClientId}`

export const paletteId = (kind, key) => `palette:${kind}:${key}`

// Parse `${sectionClientId}:${chipClientId}` / `section:${id}` /
// `section-sort:${id}` back into a section id so a drop over any part of a
// section resolves to that section.
export const sectionIdFromDndId = (id) => {
  if (typeof id !== 'string') return null
  if (id.startsWith('section-sort:')) return id.slice('section-sort:'.length)
  if (id.startsWith('section:')) return id.slice('section:'.length)
  if (id.startsWith('palette:')) return null
  const idx = id.indexOf(':')
  return idx === -1 ? null : id.slice(0, idx)
}

export const chipIdFromDndId = (id) => {
  if (typeof id !== 'string') return null
  if (
    id.startsWith('section:') ||
    id.startsWith('section-sort:') ||
    id.startsWith('palette:')
  )
    return null
  const idx = id.indexOf(':')
  return idx === -1 ? null : id.slice(idx + 1)
}

export const TYPE_OPTIONS = [
  'Vehicle',
  'Bag',
  'Device',
  'Crash Trolley',
  'Other',
]

export const SECTION_TYPE_OPTIONS = [
  'Pouch',
  'Pocket',
  'Cupboard',
  'Drawer',
  'Other',
]

export const COLOURS = {
  navy: '#242F40',
  teal: '#239AA4',
  divider: '#E2E8F0',
  trunk: '#CBD5E1',
  assetBg: '#EAF4F9',
  assetBorder: '#268EBB',
  pendingBlue: '#1F3D7C',
}
